import { useTranslation } from 'react-i18next'

import { SelectFieldModel } from '@types'

import { Option, Select } from '@components/Select'

import { Container, ItemContainer, SelectedItemLabel } from './SubmitterFieldSelect.styled'

type SubmitterFieldSelectProps = {
  field: SelectFieldModel
  onChange: (updates: Partial<SelectFieldModel>) => void
  onRedirect: (id: string) => void
  disabled?: boolean
}

export const SubmitterFieldSelect: React.FC<SubmitterFieldSelectProps> = ({
  field,
  disabled = false,
  onChange,
  onRedirect,
}: SubmitterFieldSelectProps) => {
  const { t } = useTranslation()

  const options: Option[] = field.options.map((option) => ({
    id: option.id,
    label: option.label,
    data: option,
  }))

  const getSelectedOption = (id?: string): Option | undefined => {
    const option = options.find((option) => option.id === id)
    return option
      ? {
          id: option.id,
          label: option.label,
          data: option,
          Component: () => (
            <ItemContainer>
              <SelectedItemLabel>{option.label}</SelectedItemLabel>
            </ItemContainer>
          ),
        }
      : undefined
  }

  return (
    <Container>
      <Select
        selected={getSelectedOption(field.value)}
        hideOptional
        options={options}
        label={field.label}
        placeholder={t('modules_project-forms_components_FormSubmitter_components_SubmitterFieldSelect_placeholder')}
        required={field.required}
        disabled={disabled}
        onClick={(value) => {
          value?.data.redirectTo && onRedirect(value.data.redirectTo)
          onChange({ value: value ? value?.id : undefined })
        }}
      />
    </Container>
  )
}
